import React from "react";
import { AiOutlinePhone, AiOutlineTag } from "react-icons/ai";
import { FormattedMessage } from "react-intl";

import { Tooltip } from "src/common/components/Tooltip";
import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { orgMessages } from "src/messages/generic";
import { useDialysisCentre } from "src/modules/ktx/header/hooks/useDialysisCentre";
import { messages as ktxHeaderMessages } from "src/modules/ktx/header/messages";
import { HeaderValue } from "src/modules/shared/header";

import "./Header.css";

export const DialysisCentre: React.FunctionComponent = () => {
	const { orgInfo } = useDialysisCentre();
	const formatMessage = useFormatMessageMap();

	const content = (
		<>
			<FormattedMessage {...ktxHeaderMessages.dialysisCentre} />
			{": "}
			{orgInfo ? orgInfo.code : "-"}
		</>
	);

	if (!orgInfo || !orgInfo.phoneNumber) {
		return <HeaderValue variant="d_c">{content}</HeaderValue>;
	}

	const title = (
		<div className="header-title">
			<div className="header-title__line">
				<div className="header-title__icon">
					<AiOutlinePhone />
				</div>
				{orgInfo.phoneNumber}
			</div>
			<div className="header-title__line">
				<div className="header-title__icon">
					<AiOutlineTag />
				</div>
				{formatMessage(orgMessages, orgInfo.code)}
			</div>
		</div>
	);

	return (
		<Tooltip
			title={title}
			content={<HeaderValue variant="d_c">{content}</HeaderValue>}
		/>
	);
};
